import React, { Component } from "react";
import { auth } from "../../utils/auth";
import Form from "./Form";
import { apiUrl } from "../../utils/apiUrl";
import Loader from "../general/Loader";
import { postRequest } from "../../utils/request";

class Create extends Component {
    state = {
        errors: {},
        ruta: {},
        saving: false,
    };
    createRuta = async (event) => {
        event.preventDefault();

        this.setState({ saving: true });

        const data = new FormData(event.target);

        const response = await postRequest(apiUrl("rutas"), data);

        if (response.success) {
            this.props.getRutas();
            this.props.toggle();
        }
        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }

        this.setState({ saving: false });
    };
    render() {
        const { errors, ruta, saving } = this.state;
        const { toggle } = this.props;
        return (
            <form method='post' onSubmit={this.createRuta}>
                <div className='popup__header'>Nueva Zona</div>
                <div className='popup__body'>
                    <Form ruta={ruta} errors={errors} />
                </div>
                <div className='popup__footer'>
                    <button
                        type='button'
                        onClick={toggle}
                        className='btn btn-plain'>
                        Cancelar
                    </button>
                    {saving ? (
                        <Loader type='small' />
                    ) : (
                        <button type='submit' className='btn btn-primary'>
                            Crear
                        </button>
                    )}
                </div>
            </form>
        );
    }
}

export default Create;
